'use client';
import { type Brand } from '@curology/next-multi-brand/middleware';
import { createContext } from 'react';

import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { type FlowType } from '@/services/funnelService/consts/flowType';
import { type Visit } from '@/services/visitsService/types';

export type FlowParameters = {
  brand: Brand;
  flowType: FlowType;
  treatmentCategory: TreatmentCategory;
  searchParams?: { [key: string]: string | string[] | undefined };
};

export type FlowNavigation = {
  baseRoute: string;
  currentStepRoute: string;
  nextStepRoute?: string;
  prevStepRoute?: string;
  completionUrl?: string;
};

export type FlowVisit = {
  visit?: Visit;
};

export type FlowStepMeta = {
  /**
   * Zero-based index of the step currently being rendered. Optional to avoid
   * forcing legacy flows to provide it immediately.
   */
  currentStepIndex?: number;
  /**
   * Total number of steps available in the active flow. Optional for parity
   * with legacy flows.
   */
  totalSteps?: number;
  /**
   * Convenience flag derived from currentStepIndex when available.
   */
  isInitialStep?: boolean;
};

export type FlowExecutionContext = FlowParameters &
  FlowNavigation &
  FlowVisit &
  FlowStepMeta;

export type FlowExecutionContextProp = {
  context: FlowExecutionContext;
};

export const FlowContext = createContext<FlowExecutionContext | undefined>(
  undefined,
);
